<div ktMenu [options]="menuOptions" id="kt_header_menu" class="kt-header-menu kt-header-menu-mobile">
  <ul class="kt-menu__nav">
    <ng-container *ngFor="let item of menuService.menuItems$ | async">
      <ng-container
        *ngIf="(item.title || item.titleRu || item.titleEn) && !item.submenu"
        [ngTemplateOutlet]="menuTemplate"
        [ngTemplateOutletContext]="{ item: item }"
      >
      </ng-container>
    </ng-container>
  </ul>
</div>

<ng-template #menuTemplate let-item="item" let-parentItem="parentItem">
  <ng-container
    *ngIf="!item.permissions || item.permissions.length === 0"
    [ngTemplateOutlet]="menuItemInnerTemplate"
    [ngTemplateOutletContext]="{ item: item, parentItem: parentItem }"
  >
  </ng-container>

  <ng-template
    *ngIf="item.permissions && item.permissions.length"
    [ngxPermissionsOnly]="getPermissions(item.permissions)"
  >
    <ng-container
      [ngTemplateOutlet]="menuItemInnerTemplate"
      [ngTemplateOutletContext]="{ item: item, parentItem: parentItem }"
    ></ng-container>
  </ng-template>
</ng-template>

<!-- item inner -->
<ng-template #menuItemInnerTemplate let-item="item" let-parentItem="parentItem">
  <li>
    <button
      [routerLink]="item.page"
      [ngClass]="{ 'kt-menu__toggle': item.root }"
      class="kt-menu__link btn"
      routerLinkActive="kt-menu__link-active"
    >
      <!-- if menu item has icon -->
      <i *ngIf="item.icon" class="kt-menu__link-icon" [ngClass]="item.icon"></i>

      <ng-container *ngIf="!item.icon">
        <!-- if menu item using bullet -->
        <i
          *ngIf="(parentItem && parentItem.bullet === 'dot') || item.bullet === 'dot'"
          class="kt-menu__link-bullet kt-menu__link-bullet--dot"
        >
          <span></span>
        </i>
        <i
          *ngIf="(parentItem && parentItem.bullet === 'line') || item.bullet === 'line'"
          class="kt-menu__link-bullet kt-menu__link-bullet--line"
        >
          <span></span>
        </i>
      </ng-container>

      <ng-container *ngIf="!item.badge; else menuLinkBadge">
        <span class="kt-menu__item-here"></span>
        <!-- menu item title text -->
        <span class="kt-menu__link-text">
          {{ getTitle(item) }}
        </span>
      </ng-container>

      <ng-template #menuLinkBadge>
        <!-- menu item with badge -->
        <span class="kt-menu__link-text">{{ getTitle(item) }}</span>
        <span class="kt-menu__link-badge">
          <span
            class="kt-badge kt-badge--brand kt-badge--inline kt-badge--pill"
            [ngClass]="item.badge.type"
            [transloco]="item.badge.translate"
            >{{ item.badge.value }}</span
          >
        </span>
      </ng-template>
    </button>
  </li>
</ng-template>
